// extracted by mini-css-extract-plugin
export default {"titleLink":"NotificationTitle_titleLink__P8hLV","displayLineBreak":"NotificationTitle_displayLineBreak__ZmYF8"};